export const HISTORY_TABLE_STYLES = {
  default: {
    label: 'Default',
    header: '#dbe4ee',
    odd: '#ffffff',
    even: '#eef3f8',
    hover: '#d9e4ef',

    printHeader: '#cbd8e5',
    printOdd: '#ffffff',
    printEven: '#e3ebf2',
  },

  blue: {
    label: 'Blue',
    header: '#dbeafe',
    odd: '#ffffff',
    even: '#eff6ff',
    hover: '#dbeafe',

    printHeader: '#b9d5ff',
    printOdd: '#ffffff',
    printEven: '#dcecff',
  },

  green: {
    label: 'Green',
    header: '#dcfce7',
    odd: '#ffffff',
    even: '#f0fdf4',
    hover: '#dcfce7',

    printHeader: '#b9e6c5',
    printOdd: '#ffffff',
    printEven: '#ddf2e2',
  },

  yellow: {
    label: 'Yellow',
    header: '#fef3c7',
    odd: '#ffffff',
    even: '#fefce8',
    hover: '#fef3c7',

    printHeader: '#ffe39a',
    printOdd: '#ffffff',
    printEven: '#fff0bd',
  },

  orange: {
    label: 'Orange',
    header: '#ffedd5',
    odd: '#ffffff',
    even: '#fff7ed',
    hover: '#ffedd5',

    printHeader: '#ffd0a3',
    printOdd: '#ffffff',
    printEven: '#ffe7cf',
  },

  red: {
    label: 'Red',
    header: '#fee2e2',
    odd: '#ffffff',
    even: '#fef2f2',
    hover: '#fee2e2',

    printHeader: '#ffc1c1',
    printOdd: '#ffffff',
    printEven: '#ffe0e0',
  },

  purple: {
    label: 'Purple',
    header: '#ede9fe',
    odd: '#ffffff',
    even: '#f5f3ff',
    hover: '#ede9fe',

    printHeader: '#d3c6f4',
    printOdd: '#ffffff',
    printEven: '#e9e2fb',
  },

  teal: {
    label: 'Teal',
    header: '#ccfbf1',
    odd: '#ffffff',
    even: '#f0fdfa',
    hover: '#ccfbf1',

    printHeader: '#a9e5da',
    printOdd: '#ffffff',
    printEven: '#dff4ef',
  },
};

export const DEFAULT_HISTORY_TABLE_STYLE = 'default';

export const normalizeHistoryTableStyle = (styleId) => {
  if (styleId && typeof styleId === 'string' && HISTORY_TABLE_STYLES[styleId.toLowerCase()]) {
    return styleId.toLowerCase();
  }
  return DEFAULT_HISTORY_TABLE_STYLE;
};

export async function saveHistoryTableStyle(styleId) {
  const normalized = normalizeHistoryTableStyle(styleId);
  const { apiService } = await import('../../utils/api');
  const response = await apiService.saveSettings({ history_table_style: normalized });
  const savedStyle = response?.history_table_style
    ? normalizeHistoryTableStyle(response.history_table_style)
    : normalized;

  try {
    localStorage.setItem('assessor_history_table_style', savedStyle);
  } catch (_) {}

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('settingsUpdated', { detail: response }));
  }

  return savedStyle;
}
